"use client"

import { useEffect, useState } from "react"
import styled from "styled-components"
import { useApp } from "../contexts/AppContext"

const CursorDot = styled.div`
  position: fixed;
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  pointer-events: none;
  z-index: 9999;
  mix-blend-mode: difference;
  transition: transform 0.1s ease;
  transform: translate(-50%, -50%);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`

const CursorRing = styled.div`
  position: fixed;
  width: 40px;
  height: 40px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  pointer-events: none;
  z-index: 9998;
  transition: all 0.15s ease;
  transform: translate(-50%, -50%);
  opacity: ${({ $isHovering }) => ($isHovering ? 0.5 : 1)};
  transform: ${({ $isHovering }) =>
    $isHovering ? "translate(-50%, -50%) scale(1.5)" : "translate(-50%, -50%) scale(1)"};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`

const CustomCursor = () => {
  const { mousePosition } = useApp()
  const [isHovering, setIsHovering] = useState(false)

  useEffect(() => {
    const handleMouseEnter = () => setIsHovering(true)
    const handleMouseLeave = () => setIsHovering(false)

    const interactiveElements = document.querySelectorAll('a, button, [role="button"]')

    interactiveElements.forEach((el) => {
      el.addEventListener("mouseenter", handleMouseEnter)
      el.addEventListener("mouseleave", handleMouseLeave)
    })

    return () => {
      interactiveElements.forEach((el) => {
        el.removeEventListener("mouseenter", handleMouseEnter)
        el.removeEventListener("mouseleave", handleMouseLeave)
      })
    }
  }, [])

  return (
    <>
      <CursorDot
        style={{
          left: mousePosition.x,
          top: mousePosition.y,
        }}
      />
      <CursorRing
        $isHovering={isHovering}
        style={{
          left: mousePosition.x,
          top: mousePosition.y,
        }}
      />
    </>
  )
}

export default CustomCursor
